import { all, call, put, takeLatest, ForkEffect, AllEffect } from "redux-saga/effects";
import {
  fetchSTEP3Failure,
  fetchSTEP3Success,
} from "../actions/step3Actions";
import { step3Types } from "../constants/actionTypes";
import { getAddSTEP3Details } from "../services/step3Api";

function* fetchStep3Saga({ payload }: any): any {
  try {
    const response = yield call(getAddSTEP3Details, payload);
    // 🔧 fixed: only treat real API bodies as success; surface server errorMessages
    const body = response?.data;
    if (body && (body.isSuccess === true || body.uploadedFileList)) {
      yield put(fetchSTEP3Success(body));
    } else if (body) {
      yield put(
        fetchSTEP3Success({
          ...body,
          isSuccess: body.isSuccess === true,
          errorMessages: body.errorMessages || ["Upload failed. Please try again."],
        })
      );
    } else {
      throw new Error("Empty upload response");
    }
  } catch (e: any) {
    // 🔧 fixed: stop hardcoding "Unauthorized"; prefer API / network message
    const apiMsg =
      e?.response?.data?.errorMessages?.[0] ||
      e?.response?.data?.message ||
      (typeof e === "string" ? e : e?.message) ||
      "Upload failed. Please try again.";
    yield put(
      fetchSTEP3Failure({
        error: apiMsg,
      })
    );
  }
}

function* step3Saga(): Generator<AllEffect<ForkEffect<never>>, void, unknown> {
  yield all([takeLatest(step3Types.FETCH_STEP3_REQUEST, fetchStep3Saga)]);
}

export default step3Saga;
